import { render, staticRenderFns } from "./_purgeIBCLeague.vue?vue&type=template&id=41d05fa8&scoped=true&lang=pug&"
import script from "./_purgeIBCLeague.vue?vue&type=script&lang=js&"
export * from "./_purgeIBCLeague.vue?vue&type=script&lang=js&"
import style0 from "./_purgeIBCLeague.vue?vue&type=style&index=0&id=41d05fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d05fa8",
  null
  
)

export default component.exports